export default {
    methods: {
        getAddressComponent(address, type, size) {
            if (address && address.length) {
                const results = address.filter((el) => el.types && el.types.includes(type))
                return results && results.length && results[0] && results[0][size] ? results[0][size] : null
            }
            return null
        },
    },
}
